import React from 'react'
import { Drawer, IconButton, List, Tooltip } from '@material-ui/core'
import {
  Group as GroupIcon,
  RecentActors as RecoverEmployeesIcon,
} from '@material-ui/icons'
import { withRouter } from 'react-router-dom'
import AccessControl from '../../../helpers/AccessControl/AccessControl'

// styles
import useStyles from './styles'
import clsx from 'clsx'

function ActionBar({ showStaffList, showDeletedEmployeesList, showStaff, showDeletedStaff }) {
  var classes = useStyles()

  return (
    <Drawer
      variant={'permanent'}
      open={true}
      className={classes.drawer}
    >
      <List className={classes.sidebarList}>
		<AccessControl requiredPermissions={['staff_list']}>
			<Tooltip title="Staff List" aria-label="staff list">
			<IconButton className={clsx({
				[classes.iconButton]: true,
				[classes.isActive]: showStaff,
				})} onClick={() => showStaffList()}>
				<GroupIcon />
				<span className={classes.iconLable}>Staff List</span>
			</IconButton>
			</Tooltip>
		</AccessControl>
		<AccessControl requiredPermissions={['archived_employees']}>
			<Tooltip title="Deleted Employees" aria-label="deleted employees">
			<IconButton className={clsx({
				[classes.iconButton]: true,
				[classes.isActive]: showDeletedStaff,
				})} onClick={() => showDeletedEmployeesList()}>
				<RecoverEmployeesIcon />
				<span className={classes.iconLable}>Archived Employees</span>
			</IconButton>
			</Tooltip>
		</AccessControl>
      </List>
    </Drawer>
  )
}

export default withRouter(ActionBar)
